import { j as r } from "./atoms-v218.js";
import { createContext as d, forwardRef as c, isValidElement as C, cloneElement as j, useContext as R } from "react";
import { useMergeRefs as a, FloatingPortal as P } from "./atoms-v280.js";
import { useTooltip as w } from "./atoms-v2750.js";
import { DefaultTriggerElement as y, Tooltip as E, Content as N } from "./atoms-v2751.js";
const f = d(null), p = () => {
  const e = R(f);
  if (e == null)
    throw new Error("Tooltip components must be wrapped in <Tooltip />");
  return e;
};
function m({ children: e, ...t }) {
  const n = w(t);
  return /* @__PURE__ */ r.jsx(f.Provider, { value: n, children: e });
}
m.displayName = "Tooltip";
const u = c(function({ children: t, ...n }, i) {
  const o = p(), l = t.ref, s = a([o.refs.setReference, i, l]);
  return C(t) ? j(
    t,
    o.getReferenceProps({
      ref: s,
      ...n,
      ...t.props,
      "data-state": o.open ? "open" : "closed"
    })
  ) : /* @__PURE__ */ r.jsx(
    y,
    {
      "data-state": o.open ? "open" : "closed",
      ref: s,
      ...o.getReferenceProps(n),
      children: t
    }
  );
});
u.displayName = "Tooltip.Trigger";
const T = c(function({ style: t, ...n }, i) {
  const o = p(), { Arrow: l } = o, s = a([o.refs.setFloating, i]);
  if (!o.open)
    return null;
  const { children: g, ...x } = o.getFloatingProps(n);
  return /* @__PURE__ */ r.jsx(P, { children: /* @__PURE__ */ r.jsxs(
    E,
    {
      ref: s,
      style: {
        ...o.floatingStyles,
        ...t
      },
      ...x,
      children: [
        /* @__PURE__ */ r.jsx(N, { $colorTheme: o.colorTheme, children: g }),
        l
      ]
    }
  ) });
});
T.displayName = "Tooltip.Content";
const A = Object.assign(m, { Content: T, Trigger: u, useTooltipContext: p });
export {
  A as Tooltip
};
